"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservedLocationIds = exports.ServiceLocationType = void 0;
var ServiceLocationType;
(function (ServiceLocationType) {
    ServiceLocationType["CLIENT_PLACE"] = "CLIENT_PLACE";
    ServiceLocationType["CUSTOM"] = "CUSTOM";
    ServiceLocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    ServiceLocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
})(ServiceLocationType = exports.ServiceLocationType || (exports.ServiceLocationType = {}));
var ReservedLocationIds;
(function (ReservedLocationIds) {
    ReservedLocationIds["OTHER_LOCATIONS"] = "OTHER_LOCATIONS";
    ReservedLocationIds["UNSPECIFIED_LOCATION"] = "UNSPECIFIED_LOCATION";
})(ReservedLocationIds = exports.ReservedLocationIds || (exports.ReservedLocationIds = {}));
//# sourceMappingURL=service-location.dto.js.map